import React, { memo, forwardRef } from 'react';
import { createUseStyles } from '@Sage/hoi-poi-ui';

import SageLogoSmall from '../../../icons/SageLogoSmall';
import styles from './styles';
const useStyles = createUseStyles(styles, 'SageField');

const SageField = ({ displayName }, ref) => {
    const classes = useStyles();
    return (
        <span ref={ref} className={classes.headerIcon}>
            <div className={classes.icon}>
                <SageLogoSmall />
            </div>
            {displayName}
        </span>
    );
};

export default memo(forwardRef(SageField));
